import React from 'react';
import CaseList from './CaseList';
import { APP_TERMS } from '../../app-terms';
import { CASE_STATUS_SUBMITTED } from './CaseConstants';
const BREAD_CRUMBS = [
  { label: 'Case', to: '/user/case/submitted' },
  { label: 'Submitted', to: '/user/case/submitted' },
];
const SubmittedCases = () => {
  return (
    <div>
      <div>
        <CaseList
          title={APP_TERMS.submitted_case_list_title}
          caseStatus={CASE_STATUS_SUBMITTED}
          breadCrumbItems={BREAD_CRUMBS}
        />
      </div>
    </div>
  );
};

export default SubmittedCases;
